module.exports = __webpack_public_path__ + "static/media/icon-movedown.4c7291a9.svg";